import React, { useEffect, useState } from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  useNotify,
  useRedirect,
  useUpdate,
  required,
  useDataProvider,
} from "react-admin";
import Box from "@mui/material/Box";
import { useParams } from 'react-router-dom';

interface Department {
  id: string;
  departmentName: string;
  description: string;
}

const PositionEdit: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const { id } = useParams();
  const [update] = useUpdate();
  const [departments, setDepartments] = useState<Department[]>([]);
  const [loading, setLoading] = useState(true);

  // ----------------------
  // 加载部门列表
  // ----------------------
  useEffect(() => {
    setLoading(true);

    dataProvider.getList('permissionDepartment', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'id', order: 'ASC' },
      filter: {}
    })
      .then((res) => {
        setDepartments(res.data);
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        notify('Error loading departments', { type: 'warning' });
        setLoading(false);
      });
  }, [dataProvider, notify]);

  if (loading) return <span>Loading...</span>;

  // -----------------------------
  // 保存
  // -----------------------------
  const handleSave = async (data: any) => {
    try {
      const payload: any = {
        positionName: data.positionName,
        departmentId: data.departmentId,
        description: data.description,
      };

      await update('permissionPosition', { id: id, data: payload });

      notify('Position updated successfully', { type: 'success' });
      redirect('list', 'permissionPosition');
    } catch (error) {
      notify('Update failed', { type: 'error' });
    }
  };

  const departmentChoices = departments.map(dept => ({
    id: dept.id,
    name: dept.departmentName,
  }));

  return (
    <Edit resource="permissionPosition">
      <SimpleForm sx={{ backgroundColor: '#ffffff', padding: '36px' }} onSubmit={handleSave}>

        <Box display="flex" flexWrap="wrap" gap={2}>

          {/* 职级名称 */}
          <Box flex="1 1 48%">
            <TextInput
              source="positionName"
              label="Position Name"
              fullWidth
              validate={[required()]}
            />
          </Box>

          {/* 所属部门 */}
          <Box flex="1 1 48%">
            <SelectInput
              source="departmentId"
              label="Department"
              choices={departmentChoices}
              fullWidth
              validate={[required()]}
            />
          </Box>

          {/* 职级描述 */}
          <Box flex="1 1 100%">
            <TextInput
              source="description"
              label="Position Description"
              fullWidth
              multiline
              rows={3}
            />
          </Box>

        </Box>

      </SimpleForm>
    </Edit>
  );
};

export default PositionEdit;